<template>
    <div>
        <a href="#" class="public-profile-gallery" @click.prevent="showModal()">
            <img :src="cover" alt="">
            <div>
                <span>{{word.videos}}</span>
                <span><i class="fas fa-play-circle"></i>{{ videos.length }}</span>
            </div>
        </a>

        <LightBox ref="lightbox" :media="videos" :show-light-box="false"></LightBox>
    </div>
</template>

<script>
    import LightBox from './VideoLightBox'
    require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

    export default {
        name: "videos-preview",

        components: {
            LightBox
        },

        props: [
            'userId'
        ],

        data() {
            return {
                videos: [],
                word: window.word,
                text: window.text,
                defaultThumb: '/images/layer.png',
            }
        },

        methods: {
            fetchVideos() {
                axios.get('/dashboard/user/' + this.userId + '/videos')
                    .then(response => this.videos = response.data.data)
                    .catch(error => console.log(error));
            },
            showModal() {
                if (this.videos.length) {
                    this.$refs.lightbox.showImage(0);
                    return
                }

                this.$toast.error(this.text.can_not_find_any_video_for_user);
            },
        },

        computed: {
            cover() {
                if (this.videos.length && this.videos[0].thumb) {
                    return this.videos[0].thumb;
                }
                return this.defaultThumb;
            }
        },

        async mounted() {
            await this.fetchVideos();

            Bus.$on('NewGalleryVideo', () => {
                this.fetchVideos();
            });
        }
    }
</script>
